{
  "Description": "BL : 97133",
  "RedundantCharacters": " -",
  "ValidationRegex": "^97133$",
  "TestData": {
    "Valid": [
      "97133"
    ],
    "Invalid": [
      "971330",
      "9713"
    ]
  }
}